import { useMutation } from "@apollo/client";

import { FunctionTypeFormInputs } from "../../../components/FunctionTypeForm";
import { SettingsFunctionTypeEditRoute_UpdateDocument } from "../mutations.generated";

export default function useSettingsFunctionTypeEditRoute_Update() {
    const [mutate, { loading, error }] = useMutation(SettingsFunctionTypeEditRoute_UpdateDocument, {});

    const updateFunctionType = (ecologicalFunctionTypeId: string, input: FunctionTypeFormInputs) =>
        mutate({
            variables: { input: { ...input, ecologicalFunctionTypeId } },
        });

    return {
        updateFunctionType,
        loading,
        error,
    };
}
